
import { parseToDate } from "./dateUtils";

export function getKindergartenYearNumber(birthDateStr, schoolYearStartDateStr) {
    const birthDate = parseToDate(birthDateStr);
    const schoolYearStart = parseToDate(schoolYearStartDateStr);

    if (!birthDate || !schoolYearStart) return null;

    const fourthBirthday = new Date(birthDate);
    fourthBirthday.setFullYear(fourthBirthday.getFullYear() + 4);

    if (fourthBirthday > new Date(schoolYearStart.getFullYear() + 1, 7, 31)) {
        // Wordt pas ná afloop van dit schooljaar 4 → te jong
        return null;
    }

    // Bepaal hoeveel jaren geleden het kind instroomde als 4-jarige
    const startYear = schoolYearStart.getFullYear();
    const instroomYear = fourthBirthday.getFullYear();

    return startYear - instroomYear + 1; // 1e, 2e, 3e kleuterjaar
}
